import { connect } from "react-redux";
import { PageAppointments, PageLibraryReadingListCard } from "senac-components";
import { commonSlice, contentSlice, userDataSlice } from "../store/reducers";
import { RootState, AppDispatch } from "../store";
import { Wrapper, WrapperDispatchProps, WrapperStateProps } from "./Wrapper";
import {
  Content,
  ContentGroup,
  ContentHeaderOptionItem,
  MenuOptions,
  PageLibraryHeaderOptionItem,
} from "senac-components/dist/pages/Mobile/PageInterfaces";
import {
  PageLibraryReadingListCardDispatchProps,
  PageLibraryReadingListCardStateProps,
} from "senac-components/dist/pages/Mobile/PageLibraryReadingListCard";
import {
  createTagPage,
  editTagByUid,
  FavoritesInternalTag,
} from "../store/reducers/userDataSlice";
import { loadAndOpenContent, showContentDetail } from "../store/reducers/contentSlice";
import { filterContent } from "../store/reducers/common";

const mapState = (state: RootState, props: any) => 
{
  const userState = state.userDataState;

  var data = [...userState.userData, ...userState.userDataShared ].filter(p=> p.tags && p.tags.length > 0 && p.name != FavoritesInternalTag && p.targetType == "ManagedContent" && p.contextType == "ManagedContent");
  var uniqueTags = [ ...userState.tags, ...userState.sharedTags].filter(p=> p.name != FavoritesInternalTag);
  var contentsMap:any = {};

  for (var userData of data)
  {
    for(var tag of userData.tags ?? [])
    {
      var list = contentsMap[tag.uid];

      if (!list){
        list = [];
        contentsMap[tag.uid] = list;
      }

      var contentData = state.contentState.allContents.find(p=> p.uid == userData.contextUid);
      if (contentData) list.push(contentData);
    }
  }

  var contents: ContentGroup[] = uniqueTags
    .map(tag=> {
      var contentGroup: ContentGroup = 
      {
        uid: tag.uid,
        title: tag.name,
        editable: true,
        books: contentsMap[tag.uid]
      }
      return contentGroup;
    });

  let result: PageLibraryReadingListCardStateProps = 
  {
    searchedBooks: contents,
  };
  return result;
};

const mapDispatch = (dispatch: AppDispatch, props: any) => {
  const result: PageLibraryReadingListCardDispatchProps & WrapperDispatchProps = {
    onSelectedHeaderBack: () => dispatch(commonSlice.actions.backPage()),
    onSelectedHeaderMenuOption: (option: PageLibraryHeaderOptionItem) =>dispatch(commonSlice.actions.goToLibraryOption(option)),
    onSelectedNavigationPageOption: (option: MenuOptions) => dispatch(commonSlice.actions.goToPage(option)),
    onClickCreate: () => dispatch(createTagPage()),
    onSelectedContent: (content: ContentGroup) => dispatch(showContentDetail(content.uid)),
    onEditionGroup: (group: ContentGroup) => dispatch(editTagByUid(group.uid)),
    onSelectedEditionEpub: (content: Content) =>
      dispatch(loadAndOpenContent(content.uid)),
    onChangeFilter: (filter) => {
      if (filter.query == undefined) return;
      dispatch(filterContent({ query: filter.query }));
    }
  };
  return result;
};

const WPageLibraryReadingListCard = connect(mapState, mapDispatch)(PageLibraryReadingListCard);
export { WPageLibraryReadingListCard };
